import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {PortalUser} from "@app/model/portal-user.model";
import {Router} from "@angular/router";

@Injectable({
    providedIn: 'root'
})
export class LoginService {

    get activeUser(): PortalUser {
        return this._activeUser.getValue();
    }

    set activeUser(value: PortalUser) {
        if (sessionStorage.getItem('activeUser')){
            this._activeUser.next(JSON.parse(sessionStorage.getItem('activeUser')));
        }
        if(value?.username) {
            const token = new Date().getTime().toString();
            this.isLoggedIn = new Promise<string>(resolve => resolve(token));
            sessionStorage.setItem('portalUserAuthToken', token);
        }
        this._activeUser.next(value);
        sessionStorage.setItem('activeUser', JSON.stringify(value));
    }
    isLoggedIn: Promise<string> = new Promise<string>(resolve => resolve(sessionStorage.getItem('portalUserAuthToken')));

    private _activeUser: BehaviorSubject<PortalUser> = new BehaviorSubject<PortalUser>(new PortalUser());

    constructor(private router: Router) {
    }

    getActiveUserSubject(): BehaviorSubject<PortalUser> {
        return this._activeUser;
    }

    signout() {
        sessionStorage.setItem('activeUser', '');
        sessionStorage.setItem('portalUserAuthToken', '');
        this.isLoggedIn = new Promise<string>(resolve => resolve(''));
        this.activeUser = new PortalUser();
        this.router.navigate(['/signin'])
    }

}
